import React, { useState, useEffect } from 'react';
import { Alert, ProgressBar } from 'react-bootstrap';
import _ from 'lodash';
import useDataApi from '../../utils/useDataApi';
import usePostApi from '../../utils/usePostApi';
import currencyConversion from '../../utils/currencyConversion';

import ScheduleAB from './ScheduleAB';

const type = 'schedule_ab';

export default function (drupalParams) {
  const { case_uuid, canEdit, can_see_details } = drupalParams;
  const [{ data, isLoading, isError }, { setData }] = useDataApi(
    `/ir-search/query-json?query=${type}&case_uuid=${case_uuid}`,
    {}
  );
  const [editScheduleForm, setEditScheduleForm] = useState(false);

  const transformResponseToData = (item) => {
    let schedule = {};
    schedule = Array.isArray(item.queries)
      ? _.get(item, 'queries[0].schedule_ab[0].text', [])
      : _.get(item, 'queries.schedule_ab[0].text', []);

    return schedule;
  };

  const [{ data: savedScheduleResponse, isLoading: isLoadingSave, isError: isSaveError }, setPostData] =
    usePostApi('/scheduleform/save');

  useEffect(() => {
    if (savedScheduleResponse) setData(savedScheduleResponse.content);
  }, [savedScheduleResponse]);

  const saveScheduleForm = (values) => {
    const cash = currencyConversion.toCentsOrStr(values.cash);
    const deposits = currencyConversion.toCentsOrStr(values.deposits);
    const acct_rcpt = currencyConversion.toCentsOrStr(values.acct_rcpt);
    const investments = currencyConversion.toCentsOrStr(values.investments);
    const inventory = currencyConversion.toCentsOrStr(values.inventory);
    const farming = currencyConversion.toCentsOrStr(values.farming);
    const office = currencyConversion.toCentsOrStr(values.office);
    const machinery = currencyConversion.toCentsOrStr(values.machinery);
    const property = currencyConversion.toCentsOrStr(values.property);
    const intangibles = currencyConversion.toCentsOrStr(values.intangibles);
    const others = currencyConversion.toCentsOrStr(values.others);
    const personal_total = currencyConversion.toCents(values.personal_total);
    const real_total = currencyConversion.toCents(values.real_total);
    const total = currencyConversion.toCents(values.total);

    setPostData({
      case_uuid,
      type: 'ab',
      data: {
        type,
        case_uuid,
        cash,
        deposits,
        acct_rcpt,
        investments,
        inventory,
        farming,
        office,
        machinery,
        property,
        intangibles,
        others,
        personal_total,
        real_total,
        total,
      },
    });

    setEditScheduleForm(false);
  };

  const toggleScheduleForm = () => {
    setEditScheduleForm(!editScheduleForm);
  };
  const onPastedData = (schedule) => {
    setEditScheduleForm(schedule);
  };

  if (isLoading || isLoadingSave) {
    return <ProgressBar now={100} bsStyle="info" label={`${isLoadingSave ? 'Saving in progress' : ''}`} active />;
  }

  if (isError || isSaveError) {
    return <Alert bsStyle="danger">There has been an error {`${isError ? 'loading' : 'saving'}`} Schedule data.</Alert>;
  }

  return (
    <ScheduleAB
      schedule={transformResponseToData(data)}
      canEdit={canEdit}
      can_see_details={can_see_details}
      type={type}
      editScheduleForm={editScheduleForm}
      toggleScheduleForm={toggleScheduleForm}
      onSubmit={(value) => saveScheduleForm(value)}
      onCancel={toggleScheduleForm}
      onPastedData={onPastedData}
    />
  );
}



// WEBPACK FOOTER //
// ./src/scheduleform/schedule_ab/ScheduleABContainer.jsx